
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiEcdisIec as ObiEcdisIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ecdis-iec.js';
 
 
 

 
 export const ObiEcdisIec = createComponent({
   react: React,
   tagName: 'obi-ecdis-iec',
   elementClass: ObiEcdisIecElement,
   events: {
     
   }
  });
 
 